import * as React from 'react';

import { IconName } from '../../enums';
import { BoxTitle } from '../boxTitle/boxTitle.component';
import { Icon } from '../icon/icon.component';

import {
  Container,
  ImageContainer,
  ImageElement,
  ArtistDetailsContainer,
  ImagePlaceholder
} from './artistSummary.styled';
import { ArtistSummaryProps } from './artistSummary.types';

export const ArtistSummary: React.FC<ArtistSummaryProps> = (props: ArtistSummaryProps): JSX.Element => {
  const { className, boxTitleDetails, image }: ArtistSummaryProps = props;

  return (
    <Container className={className}>
      <ImageContainer>
        {image ? (
          <ImageElement src={image} alt={boxTitleDetails.author ?? boxTitleDetails.itemName ?? ''} />
        ) : (
          <ImagePlaceholder>
            <Icon name={IconName.Image} size={50} />
          </ImagePlaceholder>
        )}
      </ImageContainer>
      <ArtistDetailsContainer>
        <BoxTitle boxTitleDetails={boxTitleDetails} />
      </ArtistDetailsContainer>
    </Container>
  );
};
